export class ApiRequestError extends Error {
    constructor(status, message, code, details) {
        super(message);
        this.name = 'ApiRequestError';
        this.status = status;
        this.code = code;
        this.details = details;
    }
}
export async function apiErrorFromResponse(response) {
    let payload;
    try {
        payload = (await response.json());
    }
    catch {
        // Non-JSON errors retain the status-based fallback below.
    }
    const nested = payload?.error && typeof payload.error === 'object' ? payload.error : undefined;
    const message = String(payload?.message || '').trim() ||
        (typeof payload?.error === 'string' ? payload.error.trim() : '') ||
        String(nested?.message || '').trim() ||
        `API request failed: ${response.status}`;
    const code = String(payload?.code || nested?.code || '').trim() || undefined;
    return new ApiRequestError(response.status, message, code, payload);
}
